// extracted by mini-css-extract-plugin
module.exports = {"logo":"_3qX0zy","vip-sub-title":"_21ljIi","text":"_2FVHGh","brand-logo":"_2xm1JU","goto-fkhome":"_3-BEeA","fk-home-logo":"_1fqNI-"};